var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCattelan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7238 31.3039L42.873 48.2099L44.665 64.6088L56.9614 68.4972L80.0664 51.0276L63.7238 31.3039Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6409 104L41.1824 85.4033L38.1731 69.7708L24.8398 63.989L1.73486 83.1492L18.6409 104Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7541 2.91293L30.2949 2C30.2949 2 30.4752 9.8895 30.4752 13.8343C30.4752 17.779 29.9117 21.1602 27.6575 25.6685C25.1216 30.7403 22.2025 35.8911 21.4586 42.0111C20.7147 48.1423 21.2332 56.9898 26.0458 65.6345C30.8697 74.2791 39.4918 85.9669 50.5033 92.9209C57.9152 97.6017 66.8453 101.254 76.6851 101.746C87.9558 102.309 94.7183 97.2376 94.7183 97.2376L94.7746 95.1074C94.7746 95.1074 65.0087 78.6296 50.7512 60.5401C41.2049 48.4354 34.4199 26.7956 37.8012 14.3978C40.0553 6.50829 40.7541 2.91293 40.7541 2.91293Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0885 68.4972C49.0719 65.6796 37.8011 76.3867 41.7459 85.9669",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4365 48.2099C34.9834 44.8287 20.8951 54.9724 25.9668 65.6795",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCattelan);
export default __webpack_public_path__ + "static/media/Cattelan.72edff84.svg";
export { ForwardRef as ReactComponent };var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCattelan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7238 31.3039L42.873 48.2099L44.665 64.6088L56.9614 68.4972L80.0664 51.0276L63.7238 31.3039Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6409 104L41.1824 85.4033L38.1731 69.7708L24.8398 63.989L1.73486 83.1492L18.6409 104Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7541 2.91293L30.2949 2C30.2949 2 30.4752 9.8895 30.4752 13.8343C30.4752 17.779 29.9117 21.1602 27.6575 25.6685C25.1216 30.7403 22.2025 35.8911 21.4586 42.0111C20.7147 48.1423 21.2332 56.9898 26.0458 65.6345C30.8697 74.2791 39.4918 85.9669 50.5033 92.9209C57.9152 97.6017 66.8453 101.254 76.6851 101.746C87.9558 102.309 94.7183 97.2376 94.7183 97.2376L94.7746 95.1074C94.7746 95.1074 65.0087 78.6296 50.7512 60.5401C41.2049 48.4354 34.4199 26.7956 37.8012 14.3978C40.0553 6.50829 40.7541 2.91293 40.7541 2.91293Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0885 68.4972C49.0719 65.6796 37.8011 76.3867 41.7459 85.9669",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4365 48.2099C34.9834 44.8287 20.8951 54.9724 25.9668 65.6795",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCattelan);
export default __webpack_public_path__ + "static/media/Cattelan.72edff84.svg";
export { ForwardRef as ReactComponent };